import { render, staticRenderFns } from "./TestReportModal.vue?vue&type=template&id=0ccbbda4&scoped=true"
import script from "./TestReportModal.vue?vue&type=script&lang=js"
export * from "./TestReportModal.vue?vue&type=script&lang=js"
import style0 from "./TestReportModal.vue?vue&type=style&index=0&id=0ccbbda4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbbda4",
  null
  
)

export default component.exports